import * as React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { MantineProvider, LoadingOverlay } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
import useStore from './store';
import AuthRoutes from "./routes/Auth";
import ProtectedRoutes from "./routes/Protected";
import 'dayjs/locale/mn';
import {ModalsProvider} from "@mantine/modals";
import Login from "./pages/auth/Login";

function App() {

    const token = useStore(state => state.auth.token);
    const loading = useStore(state => state.loading);
    const store = useStore();

    // process.env.NODE_ENV !== 'production' && console.log('store>>>', store);

    const getRoutes = () => {
        if (!token) {
            return <AuthRoutes/>
        }
        return <ProtectedRoutes/>
    }

    return (
        <MantineProvider
            withGlobalStyles
            withNormalizeCSS
            theme={{
                // primaryColor: 'violet',
                primaryColor: 'color-primary',
                colorScheme: 'light',
                focusRing: 'auto',
                activeStyles: {
                    transform: 'scale(0.99)',
                },
                loader: 'dots',
                cursorType: 'pointer',
                dateFormat: 'YYYY/MM/DD',
                datesLocale: 'mn',
                fontFamily: 'GIP',
                colors: {
                    'color-primary': [
                        "#A79CBD",
                        "#9484B5",
                        "#826BB1",
                        "#7051B2",
                        "#613CAF",
                        "#542AAC",
                        "#50318F",
                        "#4B3578",
                        "#453666",
                        "#403558",
                    ],
                    'color-secondary': [
                        "#A1C9B3",
                        "#86C3A1",
                        "#69C391",
                        "#49C781",
                        "#29CE73",
                        "#13CE66",
                        "#22A95E",
                        "#2B8C56",
                        "#2F754E",
                        "#316347",
                    ]
                    // '#13CE66'
                },
                globalStyles: () => {
                    return {

                        // Write global styles here
                    }
                },
                components: {
                    Button: {
                        defaultProps: {

                        },
                        classNames: {

                        },
                        styles: {
                            root: {
                                fontWeight: 500
                            }
                        }
                    },
                },
                defaultGradient: {
                    from: '#61009e',
                    to: '#4653b9',
                    deg: 180
                    // #542AAC mid color
                },
                other: {
                    gradientFrom: '#61009e',
                    gradientTo: '#4653b9',
                }
            }}
        >
            <ModalsProvider>
                <NotificationsProvider
                    autoClose={20_000}
                    position={'top-right'}
                >
                    <LoadingOverlay visible={loading}/>
                    <Router>
                        <Routes>
                            <Route path='/privacy-policy.html' element={<div/>} />
                            <Route path='/about.html' element={<div/>} />
                        </Routes>
                        {getRoutes()}
                    </Router>
                </NotificationsProvider>
            </ModalsProvider>
        </MantineProvider>
    )
}

export default App
